import { gql } from '@grandvisionhq/graphql';

var StoresFilter = gql`
  fragment StoresFilter on StoresFilter {
    name
    options {
      name
      count
    }
  }
`;

export { StoresFilter as default };
//# sourceMappingURL=stores-filter.js.map
